import type { ComponentType, ReactNode } from "react";
import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import type { Transaction } from "features/transactions/types";

export const enum Column {
    UpdatedAt = 'updatedAt',
    Status = 'status',
    FundStatus = 'fundStatus',
    SettlementStatus = 'settlementStatus',
    SettlementStatusDateTime = 'settlementStatusDateTime',
    IsSettled = 'isSettled',
    RefId = 'refId',
    SettledDate = 'settledDate',
    LocalTime = 'localTime',
    CreatedAt = 'createdAt',
};

export type ColumnDef<TLabel = any> = {
    readonly component?: ComponentType<{
        readonly label: TLabel;
    }>;
    readonly headerName: ReactNode;
};

export type ColumnGetter<T extends keyof Transaction> = (column: Extract<
    keyof Transaction,
    T
>) => Pick<
    GridRenderCellParams,
    | 'field'
    | 'value'
>;
